import { log } from '@/log'
import { ApiClientWithAuth } from '@/services/api/client'
import { Either, left, right } from 'fp-ts/lib/Either'

export interface LogData {
  level: 'error' | 'warn' | 'info' | 'debug'
  message: string
}

export class LoggingService {
  constructor(
    private readonly apiClient: typeof ApiClientWithAuth = ApiClientWithAuth
  ) {}

  async post(data: LogData[]): Promise<Either<Error, null>> {
    const target = `/api/logging`

    try {
      await this.apiClient.postJson(target, {
        logs: data,
      })
      log.debug({ target, data })

      return right(null)
    } catch (error) {
      log.error({ error })

      return left(new Error(`failed to post logging data: ${error}`))
    }
  }
}
